"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const InputError = (props) => {
    const { width = '32px', height = '32px' } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 32 32" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.G, { fill: "#C00", "fill-rule": "nonzero" },
                react_1.default.createElement(react_native_svg_1.G, null,
                    react_1.default.createElement(react_native_svg_1.G, null,
                        react_1.default.createElement(react_native_svg_1.Path, { d: "M16 7c-4.962 0-9 4.038-9 9s4.038 9 9 9 9-4.038 9-9-4.038-9-9-9zm1.085 3.938l-.523 6.75h-1.125l-.522-6.75h2.17zM16 21.062c-.622 0-1.125-.503-1.125-1.125 0-.621.503-1.125 1.125-1.125s1.125.504 1.125 1.125c0 .622-.503 1.125-1.125 1.125z", transform: "translate(-572 -510) translate(285 469) translate(287 41)" })))))));
};
exports.default = react_1.default.memo(InputError);
